import React, { useState, useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import {v4} from "uuid";
import axios from 'axios';
import {customAlphabet} from "nanoid" 

const generateRideId = customAlphabet("123456789", 6);

const GenerateQRSession = () => {
  const [programs, setPrograms] = useState([]);
  const [semesters, setSemesters] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [filteredSemesters, setFilteredSemesters] = useState([]);
  const [filteredSubjects, setFilteredSubjects] = useState([]);

  const [programId, setProgramId] = useState('');
  const [semesterId, setSemesterId] = useState('');
  const [subjectId, setSubjectId] = useState('');
  const [duration, setDuration] = useState(30);

  const [qrValue, setQRValue] = useState(localStorage.getItem('qrSessionCode') || '');
  const [sessionDetails, setSessionDetails] = useState(
    JSON.parse(localStorage.getItem('qrSessionData')) || null
  );
  
  const [assignedSubjects, setAssignedSubjects] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    setFilteredSemesters(semesters.filter((s) => s.program_id == programId));

    const assignedSubjectIds = assignedSubjects
      .filter((a) => a.program_id == programId && a.semester_id == semesterId)
      .map((a) => a.subject_id);

    setFilteredSubjects(subjects.filter((s) => assignedSubjectIds.includes(s.id)));
  }, [programId, semesterId, semesters, subjects, assignedSubjects]);


  const fetchData = async () => {
    const teacherId = localStorage.getItem("userId");
    const [progRes, semRes, subRes, assignedSubRes] = await Promise.all([
      axios.get('http://localhost:8081/api/admin/programs'),
      axios.get('http://localhost:8081/api/admin/semesters'),
      axios.get('http://localhost:8081/api/admin/subjects'),
      axios.get(`http://localhost:8081/api/teacher-subjects?teacherId=${teacherId}`)
    ]);

    setPrograms(progRes.data);
    setSemesters(semRes.data);
    setSubjects(subRes.data);
    setAssignedSubjects(assignedSubRes.data.subjects || []);
  };


  const handleGenerate = async () => {
    if (!programId || !semesterId || !subjectId || !duration) return alert('All fields required.');

    const teacherId = localStorage.getItem("userId");
    let session_id = generateRideId();
    const sessionCode = `${teacherId}-${programId}-${semesterId}-${subjectId}-${session_id}`;
    


    const sessionData = {
      programId,
      semesterId,
      subjectId,
      duration,
      session_id,
      teacher_id: localStorage.getItem("userId"), // Replace with real ID if needed
      session_code: sessionCode,
    };

    // Simulate API call and response
    const res = await axios.post('http://localhost:8081/api/class-sessions', sessionData);
    console.log(res.data);

    setQRValue(sessionCode);
    setSessionDetails(sessionData);
    localStorage.setItem('qrSessionCode', sessionCode);
    localStorage.setItem('qrSessionData', JSON.stringify(sessionData));
  };

  const handleEndSession = () => {
    setQRValue('');
    setSessionDetails(null);
    localStorage.removeItem('qrSessionCode');
    localStorage.removeItem('qrSessionData');
  };

  return (
    <div className="qr-session">
      <h2>Generate Class Session QR</h2>

      {!qrValue ? (
        <div className="subject-form">
          <select value={programId} onChange={(e) => setProgramId(e.target.value)}>
            <option value="">Select Program</option>
            {programs.map((p) => (
              <option key={p.id} value={p.id}>{p.name}</option>
            ))}
          </select>

          <select value={semesterId} onChange={(e) => setSemesterId(e.target.value)}>
            <option value="">Select Semester</option>
            {filteredSemesters.map((s) => (
              <option key={s.semester_id} value={s.semester_id}>{s.name}</option>
            ))}
          </select>

          <select value={subjectId} onChange={(e) => setSubjectId(e.target.value)}>
            <option value="">Select Subject</option>
            {filteredSubjects.map((s) => (
              <option key={s.id} value={s.id}>{s.name}</option>
            ))}
          </select>

          <select value={duration} onChange={(e) => setDuration(parseInt(e.target.value))}>
            <option value={30}>30 minutes</option>
            <option value={45}>45 minutes</option>
            <option value={60}>60 minutes</option>
          </select>

          <button onClick={handleGenerate} className="add-btn">Generate QR</button>
        </div>
      ) : (
        <div className="qr-details">
          <h3>Current Session</h3>
          <QRCodeSVG value={qrValue} size={200} />
          <ul style={{ marginTop: '10px' }}>
            <li><strong>Program ID:</strong> {sessionDetails.programId}</li>
            <li><strong>Semester ID:</strong> {sessionDetails.semesterId}</li>
            <li><strong>Subject ID:</strong> {sessionDetails.subjectId}</li>
            <li><strong>Duration:</strong> {sessionDetails.duration} minutes</li>
            <li><strong>Session Code:</strong> {sessionDetails.session_code}</li>
          </ul>
          <button onClick={handleEndSession} style={{ marginTop: '15px', background: 'red', color: 'white' }}>
            End Session
          </button>
        </div>
      )}
    </div>
  );
};

export default GenerateQRSession;
